var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-tooltip"},[_c('v-icon',{attrs:{"size":"14"}},[_vm._v("mdi-information-variant")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }